import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");


export const getListReglement = createAsyncThunk("reglement/listReglement", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reglement/listReglement", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const reglement = await response.json();
  return reglement;
});

const reglementReduce = createSlice({
  name: "reglement",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {




  },
  extraReducers: {

  },
});

export const { } = reglementReduce.actions;

export default reglementReduce.reducer;
